const numberFormatterRu = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const numberFormatterRuFixed = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Округляет число до двух знаков после запятой
 * @param {string|number|null} value
 * @returns {string|number|null}
 */
export const roundToTwoDecimals = (value) => {
  if (value == null || value === "") return "";
  return Math.round(Number(value) * 100) / 100;
};

/**
 * Форматирует число с разделителями тысяч (ru-RU)
 * @param {string|number|null} value
 * @param {boolean} [fixedDecimals=false]
 * @returns {string}
 */
export const formatBigNumber = (value, fixedDecimals = false) => {
  if (value === null || value === undefined || value === "")
    return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return "—";
  const formatted = fixedDecimals
    ? numberFormatterRuFixed.format(num)
    : numberFormatterRu.format(num);
  return formatted.replace(/\u00A0/g, " ");
};
